// TODO: Refactor this to use the useToast() hook from chakra-ui
import { Flex, IconButton } from '@everlywell/ui-kit';
import { X } from '@phosphor-icons/react';
import React, { createContext, useContext, useState, ReactNode } from 'react';

export type ToastType = {
  message: string;
  status: 'success' | 'error';
};

type ToastContextType = {
  showToast: (toast: ToastType) => void;
};

const ToastContext = createContext<ToastContextType>({
  showToast: () => {},
});

export const useToastContext = () => useContext(ToastContext);

export const ToastProvider = ({ children }: { children: ReactNode }) => {
  const [toast, setToast] = useState<ToastType | null>(null);

  const showToast = (toast: ToastType) => {
    setToast(toast);
    setTimeout(() => {
      setToast(null);
    }, 10000); // Hide toast after 10 seconds
  };

  const handleClose = () => {
    setToast(null);
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {/* Render toast message if exists */}
      {toast && (
        <Flex
          position="fixed"
          top={20}
          left="50%"
          width={['90%', '75%', '500px']}
          transform="translateX(-50%)"
          backgroundColor={
            toast.status === 'success' ? 'utility.success' : 'terracotta.dark'
          }
          color="tints.white"
          padding="10px 20px"
          borderRadius="md"
          alignItems="center"
          justifyContent="space-between"
          // updated zIndex to be 10000 so toast messages can be seen on cart drawer
          // cart drawer has a zIndex of 9998
          zIndex={10000}
        >
          <Flex> {toast.message}</Flex>
          <IconButton
            icon={<X />}
            size="sm"
            // This is breaking type check
            // @ts-ignore
            variant="ghost"
            color="white"
            marginLeft={4}
            onClick={handleClose}
            aria-label="Close toast message"
          />
        </Flex>
      )}
    </ToastContext.Provider>
  );
};
